import React from 'react';

function TopStats({ statsFieldNames }) {
  return (
    <dl className={`w-full mt-4 grid grid-cols-1 gap-4 sm:grid-cols-5 md:grid-cols-3  lg:grid-cols-5 xl:grid-cols-5`}>
      {statsFieldNames?.map((stat) => (
        <a
          key={stat.title}
          title={`View ${stat.title}`}
          className="flex justify-center"
          // href={stat.link}
        >
        <div
  className={`w-full border relative overflow-visible rounded-lg ${stat.bg} px-4 pt-4 pb-4 shadow-sm border-${stat.bg?.replace('bg-', 'border-')} transition-transform duration-200 hover:-translate-y-1 hover:scale-105 hover:bg-${stat.color}-50`}
>

            <div
              className={`absolute inset-0 bg-gradient-to-r from-${stat.color}-500 via-${stat.color}-500 to-${stat.color}-500 opacity-10`}
            ></div>
            <div className="flex items-center space-x-3 relative">
              <div className={`rounded-full bg-${stat.color}-500 p-2`}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  className={`h-4 w-4 text-white`}
                >
                  <path d="M10 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM3.465 14.493a1.23 1.23 0 0 0 .41 1.412A9.957 9.957 0 0 0 10 18c2.31 0 4.438-.784 6.131-2.1.43-.333.604-.903.408-1.41a7.002 7.002 0 0 0-13.074.003Z" />
                </svg>
              </div>
              <div className="flex flex-col">
                <p className="text-xs font-medium text-gray-500">{stat.title}</p>
                <p className="text-medium font-semibold text-gray-900">{stat.value}</p>
              </div>
            </div>
          </div>
        </a>
      ))}
    </dl>
  );
}

export default TopStats;